import clsx from "clsx";
import { ReactNode } from "react";

import { unstable__Button as Button } from "@hagerty/react-components";

import { BrokenCarIcon } from "./BrokenCarIcon";
import styles from "./ErrorPage.module.scss";

const DEFAULT_TITLE = "Sorry, something went wrong";
const DEFAULT_DESC = "Refresh the page or clear your cache and try again later";

type ErrorPageProps = {
  title?: ReactNode;
  description?: ReactNode;
  buttonHref?: string;
  buttonText?: string;
  className?: string;
};

export const ErrorPage = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  buttonHref,
  buttonText,
  className,
}: ErrorPageProps) => (
  <div className={clsx(styles.container, className)}>
    <div className={styles.error}>
      <BrokenCarIcon className={styles.errorIcon} />
      <h1 className={styles.errorTitle}>{title}</h1>
      <h2 className={styles.errorDescription}>{description}</h2>
      {buttonHref && buttonText && (
        <Button variant="solid" href={buttonHref}>
          {buttonText}
        </Button>
      )}
    </div>
  </div>
);
